import { TOUR_STEPS as COMMON_TOUR_STEPS, MODAL_RANGES } from 'Pages/ReportsAlerts/Reports/Common/VirtualTour/steps'

// The One Ways tour is the Common one with three differences: the Dropoff Office step becomes
// the One Way Routes step, the Export Filters step adds the sheets and says generation starts switched on, and the
// Alerts step is skipped (the section is not rendered here).
// Steps are replaced in place — never filtered out — because MODAL_RANGES uses absolute indexes.

const ES = navigator.language?.startsWith('es')

const STEP_OVERRIDES = {
	// the 'Creation Form' intro
	'drawer-start': step => ({
		...step,
		description: ES
			? 'El formulario tiene cinco secciones: Nombre, Sitios y Oficinas, Configuracion de Busqueda, Filtros de Exportacion y Frecuencia. Vamos campo por campo.'
			: 'The form has five sections: Name, Sites & Offices, Search Configuration, Export Filters, and Frequency. Let\'s go field by field.',
	}),
	dropoff: step => ({
		...step,
		findTarget: () => document.querySelector('[data-tour-id="tour-oneway"]'),
		title: ES ? 'Rutas de Solo Ida (Obligatorio)' : 'One Way Routes (Required)',
		description: ES
			? 'Las rutas de solo ida que monitorizara el informe: cada ruta define una oficina de recogida y una de devolucion distintas. Es un campo obligatorio en este tipo de informe — sin al menos una ruta no se puede guardar.'
			: 'The one way routes monitored by this report: each route defines a different pickup and dropoff office. This field is required for this report type — the report cannot be saved without at least one route.',
		example: ES ? 'Ej: Madrid Barajas (MAD) → Barcelona (BCN)' : 'E.g.: Madrid Barajas (MAD) → Barcelona (BCN)',
	}),
	'export-filters': step => ({
		...step,
		description: ES
			? 'Las hojas del Excel ("Sheets to generate") son obligatorias y siempre estan visibles: elige al menos una. El resto es opcional — elige «Show» en este selector para ver los campos. Permite filtrar los resultados del Excel por: proveedor, web supplier, politica de combustible, prepago, categoria de vehiculo y codigo ACRISS. Tambien puedes establecer un limite de horas. La generacion viene activada: si la desactivas, el informe lanza las busquedas pero no genera el Excel.'
			: 'The Excel sheets ("Sheets to generate") are required and always visible: pick at least one. The rest is optional — choose "Show" in this selector to see the fields. Allows filtering Excel results by: provider, web supplier, fuel policy, prepaid, vehicle category, and ACRISS code. You can also set an hours limit. Generation starts switched on: switch it off and the report runs its searches without building the Excel.',
	}),
	alerts: step => ({ ...step, skipIf: () => true }),
}

export const TOUR_STEPS = COMMON_TOUR_STEPS.map(step => STEP_OVERRIDES[step.id]?.(step) || step)

export { MODAL_RANGES }
